import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FaqSection = () => {
  const faqs = [
    {
      question: "How long does the Naturopathy treatment take to show results?",
      answer: "The time frame for results varies depending on the condition, its severity, and individual response to treatment. Most patients begin to see improvement within 2-4 weeks of starting treatment. Chronic conditions that have persisted for years may require 3-6 months of consistent Naturopathy therapy for significant improvement."
    },
    {
      question: "What dietary restrictions will I need to follow during treatment?",
      answer: "Dietary guidelines are an integral part of Naturopathy treatment and vary based on your specific condition and body constitution (dosha). Generally, we recommend avoiding processed foods, excessive spicy or fried items, and foods that aggravate your condition. Our doctors will provide you with personalized dietary guidelines during your consultation."
    },
    {
      question: "Can children receive treatment at your hospital?",
      answer: "Yes, we offer specialized treatments for children with chronic conditions, adjusted according to their age and body constitution. Our Naturopathy and Siddha specialists are experienced in treating conditions like juvenile arthritis, skin disorders, respiratory problems, and digestive issues in children of all ages."
    },
    {
      question: "Is there scientific evidence supporting your treatments?",
      answer: "Our treatment approaches combine traditional Yoga and Naturopathy, Siddha and Varma knowledge with modern research. Many of our herbal formulations and therapies have been validated through clinical studies, and we continuously collaborate with research institutions to document outcomes. We maintain detailed case studies and treatment efficacy data for various conditions we treat."
    }
  ];

  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-swastik-green font-medium">Common Questions</span>
          <h2 className="text-3xl md:text-4xl font-bold text-swastik-blue mb-4">Frequently Asked Questions</h2>
          <div className="h-1 w-20 bg-swastik-green mx-auto mb-8"></div>
          <p className="text-gray-600">
            Find answers to the most common questions about our treatments, procedures, and what to expect during your healing journey.
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, index) => (
              <AccordionItem key={index} value={`item-${index}`}>
                <AccordionTrigger className="text-left text-lg font-medium text-gray-900">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-gray-600">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FaqSection;
